import React, { useState } from "react";
import { FEEDBACK_SETTINGS_KEY } from "../constants/ExlyFeedback.constants";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { useFeedbackSettingsModal } from "./utils/useFeedbackSettingsModal";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import api from "data/APIs";
import { ExlyFeedbackGracePeriodModal } from "./ExlyFeedbackGracePeriodModal";

export const ExlyFeedbackModal = () => {
  const {
    closeOfferingFeedbackSettingsModal,
    offeringFeedbackSettingsModalOpen,
  } = useFeedbackSettingsModal();

  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[FEEDBACK_SETTINGS_KEY] || {};
  const { value } = subSectionConfig;

  const [selectedValueState, setSelectedValueState] = useState(value);
  const [graceModalOpen, setGraceModalOpen] = useState(false);

  const { handleSectionChange } = useAccountSectionUnlocking();

  const handleSave = () => {
    if (selectedValueState) {
      closeOfferingFeedbackSettingsModal();
      setGraceModalOpen(true);
      return;
    }

    handleSectionChange({
      endPoint: api.feedbacks.disable_customer_feedback,
      payload: {
        feature_key: FEEDBACK_SETTINGS_KEY,
        feature_value: false,
      },
    });

    closeOfferingFeedbackSettingsModal();
  };

  return (
    <>
      {graceModalOpen ? (
        <ExlyFeedbackGracePeriodModal
          baseValue={true}
          onClose={() => setGraceModalOpen(false)}
        />
      ) : (
        <ExlyModal
          title="Settings"
          header="Settings"
          primaryBtnText="Save changes"
          onPrimaryBtnClick={handleSave}
          primaryBtnProps={{ disabled: value === selectedValueState }}
          open={offeringFeedbackSettingsModalOpen}
          onClose={closeOfferingFeedbackSettingsModal}
          padded={false}
          showSecondaryBtn
          modal_props={{
            modalPaperClassName: "tw-w-[429px]",
            secondaryBtnClassName: "!tw-text-[#493ab1] !tw-min-w-[unset]",
            footerClassName: "tw-flex !tw-justify-between p-4 h-auto",
          }}
          mobile_modal_props={{
            secondaryAction: {
              label: "Cancel",
              onClick: closeOfferingFeedbackSettingsModal,
              className: "!tw-text-[#493ab1] tw-min-w-[unset]",
            },
          }}
        >
          <div className="tw-flex tw-items-start tw-p-[20px]">
            <div className="d-flex flex-column">
              <div className="tw-text-[rgba(39,37,34,0.86)] tw-text-[16px] !font-[500] mb-1">
                Disable customer feedback
              </div>
              <div className="tw-text-[rgba(39,37,34,0.6)] tw-text-[14px] tw-leading-[18px]">
                Toggle on if you prefer not to send offering feedback links to
                customers.
              </div>
            </div>
            <SectionUnlockingSwitch
              value={selectedValueState}
              onChange={() => setSelectedValueState(!selectedValueState)}
              disabled={value}
            />
          </div>
        </ExlyModal>
      )}
    </>
  );
};
